<modal-form-container title="Fix this row" [showModal]="true" (closeModalEvent)="closeModal()">
  <form class="cf" [formGroup]="contactForm" (ngSubmit)="handleSubmit()" novalidate>
    <p class="cf__lead">Changes stay in this import. Nothing is saved to your contacts until you add them at the end.</p>

    <div class="cf__grid">
      <input-field
        label="First name"
        [errorMessage]="submitted && contactForm.controls.firstName.invalid ? 'Enter a first name' : issueFor('firstName')"
      >
        <input class="input-style" formControlName="firstName" />
      </input-field>

      <input-field label="Last name" [errorMessage]="issueFor('lastName')">
        <input class="input-style" formControlName="lastName" />
      </input-field>

      <input-field
        class="cf__wide"
        label="Phone number"
        [errorMessage]="
          submitted && contactForm.controls.primaryContactNumber.invalid
            ? 'Enter a valid phone number'
            : issueFor('primaryContactNumber')
        "
      >
        <ngx-mat-input-tel
          formControlName="primaryContactNumber"
          [enablePlaceholder]="true"
          [preferredCountries]="['bw', 'za']"
          [enableSearch]="true"
        />
      </input-field>

      <input-field
        class="cf__wide"
        label="Email"
        [errorMessage]="submitted ? emailErrorMsg : issueFor('emailAddress')"
      >
        <input class="input-style" type="email" formControlName="emailAddress" />
      </input-field>

      <input-field label="Gender">
        <select name="gender" class="input-style" formControlName="gender">
          <option value="">Not set</option>
          <option value="MALE">Male</option>
          <option value="FEMALE">Female</option>
          <option value="OTHER">Other</option>
        </select>
      </input-field>

      <input-field label="Birth date" [errorMessage]="issueFor('birthDate')">
        <input class="input-style" type="date" formControlName="birthDate" />
      </input-field>

      <input-field label="Country" [errorMessage]="issueFor('country')">
        <select name="country" class="input-style" formControlName="country">
          <option value="">Not set</option>
          @for (country of countries; track country) {
            <option [value]="country">{{ country }}</option>
          }
        </select>
      </input-field>

      <input-field label="City">
        <input class="input-style" formControlName="city" />
      </input-field>

      <group-selection-input
        class="cf__wide"
        label="Organizations"
        (openSelectionEvent)="openAddOrganizationModal()"
        [selections]="selectedOrganizations"
        (removeSelectionEvent)="removeSelectedOrganization($event)"
      />
      <group-selection-input
        class="cf__wide"
        label="Tags"
        (openSelectionEvent)="openAddTagModal()"
        [selections]="selectedTags"
        (removeSelectionEvent)="removeSelectedTag($event)"
      />
    </div>

    <div class="cf__foot">
      <customizable-button title="Cancel" type="button" [outline]="true" (click)="closeModal()" />
      <customizable-button title="Save row" type="submit" />
    </div>
  </form>

  <!-- MODALS -->
  <assign-organizations-modal
    [open]="showAddOrganizationModal"
    (updateSelection)="updateSelectedOrganizations($event)"
    (close)="closeAddOrganizationModal()"
    [selection]="selectedOrganizations"
  />
  <assign-tags-modal
    [open]="showAddTagModal"
    (updateSelection)="updateSelectedTags($event)"
    (close)="closeAddTagModal()"
    [selection]="selectedTags"
  />
</modal-form-container>
